import React, { useEffect } from 'react';
import axios from 'axios';
import { withRouter } from 'react-router-dom';
import UserContext from '../Context/UserContext';

/**
 * Sing Off Component
 */
const SignOff = props => {
  useEffect(() => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    localStorage.removeItem('pets');
    //remove axios authorization;
    delete axios.defaults.headers.common['Authorization'];
    props.setLoggedIn(false);
    props.history.push('/login');

    //eslint-disable-next-line
  }, []);

  return <div />;
};

const SignOffComponent = props => (
  <UserContext.Consumer>
    {context => <SignOff {...context} {...props} />}
  </UserContext.Consumer>
);

export default withRouter(SignOffComponent);
